import { Typography } from '@bgzt/ui';
import { checkPromotionSchedule } from '~/app/_utils';

import { PROMOTION_2026_03 } from '~/app/_constants/promotion';

import styles from './Banner.module.scss';
import { TossPromotionBanner } from '../TossPromotionBanner';

type Props = {
  price?: number;
};
export const Banner = ({ price }: Props) => {
  const isOn_08_09_PromotionSchedule = checkPromotionSchedule(
    PROMOTION_2026_03.SCHEDULE.START_DATE,
    PROMOTION_2026_03.SCHEDULE.END_DATE,
  );
  const isPriceAbove50K = price && price >= 50_000;

  if (isPriceAbove50K && isOn_08_09_PromotionSchedule) return <TossPromotionBanner />;

  return (
    <div className={styles.wrapper} style={{ backgroundColor: '#F0F9FF' }}>
      <Typography variant="L12" as="p" color="gray-900">
        <Typography variant="L11" color="#099CE5">
          일본
        </Typography>
        에서 배송되는 상품이에요
      </Typography>
    </div>
  );
};
